<div class="notification-container" [ngClass]="getContainerClasses()">
  <div 
    *ngFor="let notification of notifications$ | async; trackBy: trackByNotificationId"
    class="notification-item"
    [ngClass]="getNotificationClasses(notification)"
    [@slideIn]>
    
    <div class="notification-content">
      <div class="notification-header">
        <div class="notification-icon">
          <mat-icon [style.color]="getNotificationColor(notification.type)">
            {{ getNotificationIcon(notification.type) }}
          </mat-icon>
        </div>
        
        <div class="notification-text">
          <h6 class="notification-title">{{ notification.title }}</h6>
          <p class="notification-message">{{ notification.message }}</p>
        </div>
        
        <button 
          class="notification-close"
          (click)="removeNotification(notification.id)"
          mat-icon-button>
          <mat-icon>close</mat-icon>
        </button>
      </div>
      
      <div class="notification-actions" *ngIf="notification.actions && notification.actions.length > 0">
        <button 
          *ngFor="let action of notification.actions"
          class="notification-action-btn"
          [ngClass]="'btn-' + (action.style || 'primary')"
          (click)="executeAction(notification, action)">
          {{ action.label }}
        </button>
      </div>
    </div>
    
    <div class="notification-progress" *ngIf="!notification.persistent">
      <div class="progress-bar"></div>
    </div>
  </div>
</div>
